// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3wOus","label":"Section_label__2xZgU","contentWrap":"Section_contentWrap__1oWd2","footer":"Section_footer__JuHAP","footerInner":"Section_footerInner__1f9NP"};